import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BackgroundAdapter } from './subsections/background/adapter'
import { CardiacAdapter } from './subsections/cardiac/adapter'
import { CognitivePsychosocialAdapter } from './subsections/cognitive-psychosocial/adapter'
import { EndocrineAdapter } from './subsections/endocrine/adapter'
import { GastrointestinalAdapter } from './subsections/gastrointestinal/adapter'
import { HistoryAdapter } from './subsections/history/adapter'
import { ImmunizationsAdapter } from './subsections/immunizations/adapter'
import { IntegumentaryAdapter } from './subsections/integumentary/adapter'
import { LinesDrainsAdapter } from './subsections/lines-drains/adapter'
import { MusculoskeletalAdapter } from './subsections/musculoskeletal/adapter'
import { NeurologicalAdapter } from './subsections/neurological/adapter'
import { PainAdapter } from './subsections/pain/adapter'
import { PhysicianNotificationAdapter } from './subsections/physician-notification/adapter'
import { RespiratoryAdapter } from './subsections/respiratory/adapter'
import { RiskAssessmentAdapter } from './subsections/risk-assessment/adapter'
import { SensoryAdapter } from './subsections/sensory/adapter'
import { TherapiesAdapter } from './subsections/therapies/adapter'
import { VitalsAdapter } from './subsections/vitals/adapter'
import { CareCoordinationAdapter } from './subsections/care-coordination/adapter'
import { RocFormData } from '../../types/RocFormData'
import { AdapterOptions, FlatAnswerMutation } from '../../../adapters/types'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'

/**
 * Array of all medical background subsection adapter instances
 */
const MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS: BaseSubsectionAdapter<RocFormData>[] = [
  new BackgroundAdapter(),
  new CardiacAdapter(),
  new CognitivePsychosocialAdapter(),
  new EndocrineAdapter(),
  new GastrointestinalAdapter(),
  new HistoryAdapter(),
  new ImmunizationsAdapter(),
  new IntegumentaryAdapter(),
  new LinesDrainsAdapter(),
  new MusculoskeletalAdapter(),
  new NeurologicalAdapter(),
  new PainAdapter(),
  new PhysicianNotificationAdapter(),
  new RespiratoryAdapter(),
  new RiskAssessmentAdapter(),
  new SensoryAdapter(),
  new TherapiesAdapter(),
  new VitalsAdapter(),
  new CareCoordinationAdapter()
]

/**
 * Medical Background section adapter
 * Aggregates all medical background subsections
 */
export class MedicalBackgroundAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<RocFormData> {
    const formData: Partial<RocFormData> = {}

    // Extract data from all subsection adapters
    for (const adapter of MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS) {
      const subsectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, subsectionData)
    }

    return formData
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    // Build mutations from all subsection adapters
    for (const adapter of MEDICAL_BACKGROUND_SUBSECTION_ADAPTERS) {
      adapter.setFormData(this.formData)
      const subsectionMutations = adapter.buildFlatAnswers()
      mutations.push(...subsectionMutations)
    }

    return mutations
  }
}
